module.exports = require('./helpers/bundle-url').getBundleURL('2LpMj') + "pin_blue.3fb96e91.png" + "?" + Date.now();